import { readBuiltInSkillFiles } from "./readSkill.macro" with { type: "macro" };
import { parseSkills } from "./catalog";

export const skillFiles: Record<string, string> = readBuiltInSkillFiles();

export const skills = parseSkills(skillFiles);

export { parseSkill, type Skill } from "./catalog";
